/**
 * Carry an invite `next` param (e.g. `/join/<room>`) between the auth
 * screens so a player who arrives from an invite link lands on that table
 * after signing in, signing up or verifying.
 */
export const withNext = (path: string, next?: string | null) => {
  const value = next?.trim();
  if (!value) return path;
  const joiner = path.includes('?') ? '&' : '?';
  return `${path}${joiner}next=${encodeURIComponent(value)}`;
};
